import React, { useEffect, useRef, useState } from "react";
import styles from "./activeBanner.module.scss";
import { GenCustomTable } from "../../components/customComponents/genCustomTable/GenCustomTable";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Select,
  MenuItem,
} from "@mui/material";
import CustomButton from "../../components/customComponents/customButton/CustomButton";
import { useS3Upload } from "../../customHooks/S3Upload";
import {
  Add,
  CheckCircleOutline,
  Numbers,
  UploadFile,
} from "@mui/icons-material";
import OutlinedButton from "../../components/customComponents/outlinedButton/OutlinedButton";
import SearchInput from "../../components/uiComponents/searchInput/SearchInput";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
import { connect, useDispatch } from "react-redux";
import { DESTINATIONS } from "../../utils/common/constants";
import {
  createBanner,
  getActiveBanners,
  updateBanner,
  getAllProduct,
  getAllCategory,
} from "../../store/actions";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CameraswitchOutlinedIcon from "@mui/icons-material/CameraswitchOutlined";
import CloseIcon from "@mui/icons-material/Close";

const columns = [
  {
    id: 1,
    label: "S.NO",
    minWidth: 120,
    align: "center",
  },
  {
    id: 2,
    label: "IMAGE",
    minWidth: 170,
    align: "center",
  },
  {
    id: 3,
    label: "BANNER NAME",
    minWidth: 170,
    align: "center",
  },
  {
    id: 4,
    label: "DESCRIPTION",
    minWidth: 170,
    align: "center",
  },
  {
    id: 5,
    label: "REDIRECT URL",
    minWidth: 170,
    align: "center",
  },
  {
    id: 6,
    label: "START DATE",
    minWidth: 170,
    align: "center",
  },
  {
    id: 7,
    label: "END DATE",
    minWidth: 170,
    align: "center",
  },
  {
    id: 8,
    label: "ACTION",
    minWidth: 170,
    align: "center",
  },
];

const ActiveBanner = ({
  banners = [],
  banner = {},
  products = [],
  categories = [],
}) => {
  const dispatch = useDispatch();
  const [filteredData, setFilteredData] = useState([]);
  const [searched, setSearched] = useState("");
  const [open, setOpen] = useState(false);
  const [bannerRes, setBannerRes] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [values, setValues] = useState({
    name: "",
    imageUrl: "",
    description: "",
    redirectUrl: "",
    startDate: "",
    endDate: "",
  });
  const [images, uploadImages] = useS3Upload();
  const [selected, setSelected] = useState(1);
  const filInputRef = useRef(null);
  const [linkType, setLinkType] = useState(""); // 'product' | 'category'
  const [linkTargetId, setLinkTargetId] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");

  useEffect(() => {
    dispatch(getActiveBanners());
  }, []);

  const getUrl = (item) => {
    setPreviewUrl(item?.imageUrl || "");
  };

  const handleUploadFiles = async (e) => {
    const files = e.target.files;
    if (files?.length > 0) {
      const file = files[0];
      const uploadUrl = await uploadImages(
        "image",
        file,
        DESTINATIONS?.BANNER_DETAILS
      );

      handleInputChange("imageUrl", uploadUrl);
    }
  };

  const handleClickOpen = () => {
    setIsEdit(false);
    setLinkType("");
    setLinkTargetId("");
    handleInputChange("redirectUrl", "");
    setOpen(true);
  };

  const handleClose = () => {
    setIsEdit(false);
    setOpen(false);
    setValues({});
    setBannerRes({});
    setLinkType("");
    setLinkTargetId("");
    dispatch(getActiveBanners());
  };

  const handleInputChange = (key, value) => {
    setValues((prev) => {
      const updatedValues = {
        ...prev,
        [key]: value,
      };
      console.log("Updated values:", updatedValues);
      return updatedValues;
    });
  };

  const triggerFileInput = () => {
    if (filInputRef.current) {
      filInputRef.current.click();
    }
  };

  const handleEditChanges = (item) => {
    console.log("ite", item);
    setIsEdit(true);
    setSelected(item?.status);
    setBannerRes(item);
    setValues({
      name: item?.name || "",
      imageUrl: item?.imageUrl || "",
      description: item?.description || "", // You used bannerDescription in table
      redirectUrl: item?.redirectUrl || "",
      startDate: item?.startDate || "",
      endDate: item?.endDate || "",
    });
    console.log("link", item?.type);
    setLinkType(item?.type);
    // setLinkTargetId(item?.contentType);

    // Try to infer dropdown selections from existing redirectUrl
    const url = item?.redirectUrl || "";
    if (item?.type === "product") {
      setLinkType("product");
      // const id = url.split("/product/")?.[1]?.split(/[/?#]/)?.[0] || "";
      setLinkTargetId(item?.contentType || "");
      // Ensure products are loaded for edit state
      dispatch(getAllProduct());
    } else if (item?.type === "category") {
      setLinkType("category");
      // const id = url.split("/category/")?.[1]?.split(/[/?#]/)?.[0] || "";
      setLinkTargetId(item?.contentType || "");
      // Ensure categories are loaded for edit state
      dispatch(getAllCategory());
    } else {
      setLinkType("");
      setLinkTargetId("");
    }
    setOpen(true);
  };

  console.log("sellected ids", selected);

  const getStructuredRows = (data = []) => {
    const structuredRows = data?.map((item, idx) => ({
      id: item?.id,
      rColumns: [
        idx + 1,
        <div className={styles.imgtable}>
          <Button
            variant="outlined"
            className={styles.ovalButtonOutImg}
            disableRipple
            disableElevation
            onClick={() => getUrl(item)}
          >
            View
          </Button>
        </div>,
        item?.name,
        item?.description,
        <a
          href={`${process.env.REACT_APP_FRONTEND_URL}${item?.redirectUrl}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {`${process.env.REACT_APP_FRONTEND_URL}${item?.redirectUrl}`}
        </a>,
        item?.startDate,
        item?.endDate,
        <div
          className={styles.imgtable}
          onClick={() => handleEditChanges(item)}
        >
          <EditIcon color="primary" />
          EDIT
        </div>,
      ],
    }));

    return structuredRows;
  };

  console.log("values", values);
  console.log("selectedId", selected);

  const formatDateToYYYYMMDD = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d)) return ""; // invalid date
    return d.toISOString().split("T")[0];
  };
  const handleSearch = (value) => {
    setSearched(value);
    if (value.trim() === "") {
      setFilteredData([]);
    } else {
      const filtered = handleFilter()?.filter((item) =>
        item?.name?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredData(filtered);
    }
  };

  const handleSaveChanges = () => {
    const payload = {
      name: values?.name,
      imageUrl: values?.imageUrl,
      description: values?.description,
      redirectUrl: values?.redirectUrl,
      startDate: values?.startDate,
      endDate: values?.endDate,
      status: selected,
      type: linkType,
      contentType: linkTargetId,
    };
    if (bannerRes?.id) {
      dispatch(
        updateBanner({
          payload: { ...bannerRes, ...payload },
          callback: { success: () => handleClose() },
        })
      );
    } else {
      dispatch(
        createBanner({
          payload: payload,
          callback: { success: () => handleClose() },
        })
      );
    }
  };
  const handleFilter = () => {
    const filterData = banners?.filter((item) => item?.status === 1);
    return filterData;
  };

  const isFormModified = () => {
    const hasChanges =
      values?.name !== bannerRes?.name ||
      values?.imageUrl !== bannerRes?.imageUrl ||
      values?.description !== bannerRes?.description ||
      values?.redirectUrl !== bannerRes?.redirectUrl ||
      values?.startDate !== bannerRes?.startDate ||
      values?.endDate !== bannerRes?.endDate ||
      selected !== bannerRes?.status;

    const isValid =
      values?.name && values?.imageUrl && values?.startDate && values?.endDate;

    return bannerRes?.id ? (!hasChanges ? hasChanges : isValid) : isValid;
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.topWrapper}>
          <div className={styles.top}></div>
          <div className={styles.search}>
            {/* <SearchInput
              placeholder="Search banner name"
              onSearch={handleSearch}
            /> */}
            {/* <Button
              variant="outlined"
              startIcon={<FilterAltOutlinedIcon />}
              className={styles.filterButton}
            >
              Filter
            </Button> */}
            <CustomButton
              title={"Add"}
              txtClr={"#FFFFFF"}
              background={"black"}
              width={"141px"}
              height={"48px"}
              borderRadius={"12px"}
              onClick={() => handleClickOpen()}
            />
          </div>
        </div>
        {/* Image preview modal overlay */}
        <Dialog
          open={!!previewUrl}
          onClose={() => setPreviewUrl("")}
          maxWidth="md"
          fullWidth
          PaperProps={{
            className: styles.previewPaper,
            sx: { borderRadius: "12px" },
          }}
        >
          <DialogContent classes={{ root: styles.previewContainer }}>
            <IconButton
              className={styles.previewClose}
              size="small"
              onClick={() => setPreviewUrl("")}
            >
              <CloseIcon />
            </IconButton>
            {previewUrl && (
              <img
                src={previewUrl}
                alt="Banner Preview"
                className={styles.previewImage}
              />
            )}
          </DialogContent>
        </Dialog>
        <div className={styles.bottom}>
          <GenCustomTable
            columns={columns}
            rows={getStructuredRows(
              searched.trim() ? filteredData : handleFilter()
            )}
          />
        </div>
        <Dialog
          classes={{ root: styles.dialog }}
          open={open}
          PaperProps={{
            sx: {
              borderRadius: "16px",
            },
          }}
          onClose={handleClose}
        >
          <DialogTitle id="responsive-dialog-title">
            {/* {selectedDocument?.title} */}{" "}
            {isEdit ? "Edit Banner" : "Add Banner"}
          </DialogTitle>
          <DialogContent classes={{ root: styles.dialogContainer }}>
            <div className={styles.dialogContent}>
              <div className={styles.status}>
                <div
                  className={
                    selected === 1 ? styles.activeSelected : styles.option
                  }
                  onClick={() => setSelected(1)}
                >
                  Active
                </div>
                <div
                  className={
                    selected === 0 ? styles.inactiveSelected : styles.option
                  }
                  onClick={() => setSelected(0)}
                >
                  Inactive
                </div>
              </div>
              {!values.imageUrl ? (
                <FormControl
                  fullWidth
                  margin="none"
                  className={styles.uploadedInputWrapper}
                >
                  <InputLabel htmlFor="uploaded-image-name">
                    Upload Image*
                  </InputLabel>
                  <OutlinedInput
                    id="uploaded-image-name"
                    label="Image Name"
                    sx={{ borderRadius: "12px" }}
                    value={values?.imageUrl}
                    readOnly
                    disabled
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton onClick={triggerFileInput}>
                          <UploadFile className={styles.reuploadIcon} />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              ) : (
                <div className={styles.dialogBottom}>
                  <FormControl fullWidth margin="none">
                    <InputLabel htmlFor="uploaded-image-name">
                      Upload Image*
                    </InputLabel>
                    <OutlinedInput
                      fullWidth
                      id="uploaded-image-name"
                      label="Upload Image"
                      sx={{ borderRadius: "12px" }}
                      disabled
                      value={values?.imageUrl}
                      readOnly
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton>
                            <CheckCircleOutlineIcon color="success" />
                            {/* <UploadFile className={styles.reuploadIcon} /> */}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  <div
                    className={styles.iconWrapper}
                    onClick={triggerFileInput}
                  >
                    {" "}
                    <CameraswitchOutlinedIcon color="success" />
                  </div>
                </div>
              )}

              <input
                type="file"
                ref={filInputRef}
                hidden
                accept="image/png, image/jpeg"
                onChange={handleUploadFiles}
              />

              <FormControl fullWidth margin="none">
                <InputLabel htmlFor="banner-name">Banner Name*</InputLabel>
                <OutlinedInput
                  fullWidth
                  id="banner-name"
                  sx={{ borderRadius: "12px" }}
                  label="Banner Name"
                  value={values?.name}
                  onChange={(e) => handleInputChange("name", e.target.value)}
                />
              </FormControl>

              <FormControl fullWidth margin="none">
                <InputLabel htmlFor="banner-description">
                  Banner Description*
                </InputLabel>
                <OutlinedInput
                  fullWidth
                  sx={{ borderRadius: "12px" }}
                  id="banner-description"
                  label="Banner Description"
                  value={values?.description}
                  onChange={(e) =>
                    handleInputChange("description", e.target.value)
                  }
                />
              </FormControl>

              {/* Link type selector */}
              <FormControl fullWidth margin="none">
                <InputLabel id="link-type-label">Link Type</InputLabel>
                <Select
                  labelId="link-type-label"
                  id="link-type"
                  label="Link Type"
                  value={linkType}
                  onChange={(e) => {
                    const type = e.target.value;
                    setLinkType(type);
                    setLinkTargetId("");
                    // Clear redirectUrl until a target is picked
                    handleInputChange("redirectUrl", "");
                    if (type === "product") dispatch(getAllProduct());
                    if (type === "category") dispatch(getAllCategory());
                  }}
                  sx={{ borderRadius: "12px" }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value="product">Product</MenuItem>
                  <MenuItem value="category">Category</MenuItem>
                </Select>
              </FormControl>

              {/* Target selector, visible after linkType chosen */}
              {linkType && (
                <FormControl fullWidth margin="none">
                  <InputLabel id="link-target-label">
                    {linkType === "product"
                      ? "Select Product"
                      : "Select Category"}
                  </InputLabel>
                  <Select
                    labelId="link-target-label"
                    id="link-target"
                    label={
                      linkType === "product"
                        ? "Select Product"
                        : "Select Category"
                    }
                    value={linkTargetId}
                    onChange={(e) => {
                      const id = e.target.value;
                      setLinkTargetId(id);
                      // Construct a simple redirect URL based on selection
                      const url =
                        linkType === "product"
                          ? `products/PROD-${id}`
                          : `products?category=${id}`;
                      handleInputChange("redirectUrl", url);
                    }}
                    sx={{ borderRadius: "12px" }}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {(linkType === "product" ? products : categories)?.map(
                      (opt) => (
                        <MenuItem
                          key={`${linkType}-${opt?.id}`}
                          value={opt?.id}
                        >
                          {opt?.name || opt?.id}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
              )}

              <FormControl fullWidth>
                <InputLabel htmlFor={`Start date`}>Start date*</InputLabel>
                <OutlinedInput
                  startAdornment={<Numbers style={{ paddingRight: "10px" }} />}
                  id={`start-date`}
                  sx={{ borderRadius: "12px" }}
                  label={`Start date`}
                  type={"date"}
                  value={formatDateToYYYYMMDD(values?.startDate)}
                  onChange={(e) => {
                    handleInputChange("startDate", e.target.value);
                  }}
                />
              </FormControl>

              <FormControl fullWidth>
                <InputLabel htmlFor={`End date`}>End Date*</InputLabel>
                <OutlinedInput
                  startAdornment={<Numbers style={{ paddingRight: "10px" }} />}
                  id={`end-date`}
                  sx={{ borderRadius: "12px" }}
                  label={`End Date`}
                  type={"date"}
                  value={formatDateToYYYYMMDD(values?.endDate)}
                  onChange={(e) => {
                    handleInputChange("endDate", e.target.value);
                  }}
                />
              </FormControl>
            </div>
          </DialogContent>

          <DialogActions>
            <OutlinedButton
              title={"Close"}
              txtClr={"hsla(187, 98%, 16%, 1)"}
              border={"1px solid hsla(187, 98%, 16%, 1)"}
              width={"90px"}
              height={"34px"}
              borderRadius={"12px"}
              disabled={Object.keys(values)?.length === 0}
              onclick={handleClose}
            />
            <CustomButton
              title={"OK"}
              txtClr={"#FFFFFF"}
              background={!isFormModified() ? "grey" : "hsla(187, 98%, 16%, 1)"}
              width={"90px"}
              height={"34px"}
              borderRadius={"12px"}
              disabled={!isFormModified()}
              onClick={handleSaveChanges}
            />
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    banners: state?.banner?.banners,
    banner: state?.banner?.banner,
    products: state?.product?.products,
    categories: state?.category?.categories,
  };
};
export default connect(mapStateToProps, null)(ActiveBanner);
